import Box from '@mui/material/Box';
import classNames from 'classnames';
import { Fragment, useEffect, useRef } from 'react';
import { _ } from '/@/locale';
import ProgressBarTable from '../progress-bar-cp-dskt';
import CriticalPeriod from './criticalperiod';
import styles from './styles.module.css';

const Button = ({ direction, scrollToDirection, sx }) => {
    const onClick = () => {
        scrollToDirection(direction);
    };

    return (
        <Box component='button' onClick={onClick} sx={sx}>
            <span className='material-icons'>{direction === 'left' ? 'arrow_back' : 'arrow_forward'}</span>
        </Box>
    );
};

const ProgressBarDesktop = ({
    showCropProtection,
    steps,
    activeStep,
    isActiveStep,
    getClassStep,
    getDate,
    getDataStep,
    technology,
    activeClassStep,
    showExpectedFloweringDate,
}) => {
    const scrollableContainerRef = useRef();

    /**
     *
     * @param {number} stepIndex
     */
    const scrollToStep = (stepIndex) => {
        const lastPosibleStepIndex = Math.ceil(
            (scrollableContainerRef.current.scrollWidth - scrollableContainerRef.current.offsetWidth) / 90
        );

        const newStepIndex = Math.max(0, Math.min(stepIndex, steps.length - 1, lastPosibleStepIndex));

        const element = document.getElementById(`step-${newStepIndex}`);

        scrollableContainerRef.current.scrollLeft = element.offsetLeft - scrollableContainerRef.current.offsetLeft;
    };

    const getCurrentScrolledStepIndex = () => Math.floor(scrollableContainerRef.current.scrollLeft / 90);

    /**
     *
     * @param {'left'|'right'} direction
     */
    const scrollToDirection = (direction) => {
        const currentStepIndex = getCurrentScrolledStepIndex();
        if (direction == 'right') scrollToStep(currentStepIndex + 1);
        else scrollToStep(currentStepIndex - 1);
    };

    useEffect(() => {
        if (activeStep) scrollToStep(activeStep - 1);
    }, [activeStep]);

    const showButtons =
        scrollableContainerRef.current &&
        scrollableContainerRef.current.clientWidth !== scrollableContainerRef.current.scrollWidth;

    return (
        <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
            <Button
                scrollToDirection={scrollToDirection}
                direction='left'
                sx={[!showButtons && { display: 'hidden' }]}
            />

            <Box
                sx={{ py: 5, mb: 2, overflowX: 'scroll' }}
                ref={scrollableContainerRef}
                data-testid='progress-bar-desktop-container'
            >
                <ol className={styles.progress}>
                    {steps.map((step, index) => {
                        return (
                            <li
                                id={`step-${index}`}
                                key={index}
                                data-step={getDataStep(index, activeStep)}
                                className={classNames({
                                    [styles.point]: isActiveStep(index, activeStep),
                                    [styles[`${getClassStep(step, index, activeStep)}`]]: !isActiveStep(
                                        index,
                                        activeStep
                                    ),
                                    [styles[`${getClassStep(step, index, activeStep)}-not-active`]]: activeClassStep(
                                        step,
                                        index,
                                        activeStep
                                    ),
                                })}
                            >
                                <div className={styles.containerStateDate}>
                                    {!step.empty && (
                                        <Fragment>
                                            <div
                                                className={classNames(
                                                    styles.state,
                                                    styles[`state-${getClassStep(step, index, activeStep)}`]
                                                )}
                                            >
                                                {_(step.displayName)}
                                                <span
                                                    className={classNames(
                                                        styles.tip,
                                                        styles[`tip-${getClassStep(step, index, activeStep)}`]
                                                    )}
                                                />
                                            </div>
                                            <div
                                                className={classNames(
                                                    styles.vl,
                                                    styles[`vl-${getClassStep(step, index, activeStep)}`]
                                                )}
                                            />
                                            {showExpectedFloweringDate &&
                                                !step.empty &&
                                                step.displayName === _('R1') && <CriticalPeriod />}
                                        </Fragment>
                                    )}
                                    <div
                                        className={classNames(styles.date, {
                                            [styles.pointDate]: index === activeStep,
                                        })}
                                    >
                                        {getDate(step, index)}
                                    </div>
                                </div>
                            </li>
                        );
                    })}
                </ol>
                {showCropProtection && (
                    <ProgressBarTable technology={technology} type='desktop' steps={steps} activeStep={activeStep} />
                )}
            </Box>

            <Button
                scrollToDirection={scrollToDirection}
                direction='right'
                sx={[!showButtons && { display: 'hidden' }]}
            />
        </Box>
    );
};

export default ProgressBarDesktop;
